import {
    createApp
} from 'vue'
import App from './App.vue'

const app = createApp(App);

import axios from 'axios';
import VueCookies  from 'vue-cookies';

// 路由
import router from './router/index.js'
// pxtorem
import './util/rem.js'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import commonApi from './util/commonApi.js'
app.config.globalProperties.$commonApi = commonApi;

import cookie from 'vue-cookies'
app.config.globalProperties.$cookie = cookie;

// 全局css
import './static/css/css.css'

app.use(router).use(ElementPlus).mount('#app')